// extracted by mini-css-extract-plugin
export default {"planContent":"EditPlan_planContent__SXq+I","divider":"EditPlan_divider__ZdjNF","rightStyle":"EditPlan_rightStyle__GzS1i","editPlanWrapper":"EditPlan_editPlanWrapper__rzybX"};